import { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    path: "",
    component: () => import("../pages/MediaPlansMain.vue"),
    children: [
      {
        path: "create/mediaplan",
        name: "create-mediaplan",
        component: () => import("../components/MediaPlanCreate.vue"),
      },
      {
        path: ":mediaplan_name",
        name: "mediaplan",
        component: () => import("../components/MediaPlanDetail.vue"),
      },
    ],
  },
];

export default routes;
